import { AllReportsModels } from './AnalyzeReportModelTypes'

export enum DriverMetricReportDriverColumns {
  DriverId = 'driverId',
  DriverName = 'driverName',
  CreatedAtTime = 'createdAtTime',
  LastSeenTime = 'lastSeenTime',
  Status = 'status',
  Rating = 'rating',
}

export enum DriverMetricReportDutyColumns {
  TotalDuties = 'totalDuties',
  ScheduledVehicleHourS = 'scheduledVehicleS',
  ActualVehicleHourS = 'actualVehicleS',
  RevenueHours = 'revenueHours',
  TotalTravelDistanceM = 'totalTravelDistanceM',
  DeadheadTravelDistanceM = 'deadheadTravelDistanceM',
  TotalRevenueDistanceM = 'totalRevenueDistanceM',
  TotalRequests = 'totalRequests',
  TotalFareCollected = 'totalFareCollected',
  TotalLatePullouts = 'totalLatePullouts',
  TotalPulloutLatenessMinutes = 'totalPulloutLatenessMinutes',
  TotalPulloutsOverTenMinutesLate = 'totalPulloutsOverTenMinutesLate',
  AveragePulloutLatenessMinutes = 'averagePulloutLatenessMinutes',
  TotalDutyDelays = 'totalDutyDelays',
  TotalDutyDelayMinutes = 'totalDutyDelayMinutes',
  TotalDutyDelaysOverTenMinutes = 'totalDutyDelaysOverTenMinutes',
  AverageDutyDelayMinutes = 'averageDutyDelayMinutes',
}

export enum DriverMetricReportBoardingColumns {
  TotalBoardings = 'totalBoardings',
}

/**
 * Models that are included in the Driver Report
 *
 * The order here controls the order of models on the 'Edit Columns' modal
 */
export const DriverMetricReportModelNamesArray = [
  AllReportsModels.Driver,
  AllReportsModels.Duty,
  AllReportsModels.Boarding,
]

export type IDriverMetricReportColumns =
  | DriverMetricReportDriverColumns
  | DriverMetricReportDutyColumns
  | DriverMetricReportBoardingColumns

export const DriverMetricReportModelAndColumns = {
  [AllReportsModels.Driver]: DriverMetricReportDriverColumns,
  [AllReportsModels.Duty]: DriverMetricReportDutyColumns,
  [AllReportsModels.Boarding]: DriverMetricReportBoardingColumns,
}

export const DriverMetricReportColumnNames = Object.values<IDriverMetricReportColumns>(DriverMetricReportDriverColumns)
  .concat(Object.values(DriverMetricReportDutyColumns))
  .concat(Object.values(DriverMetricReportBoardingColumns))
